import { Component, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Angular2CsvComponent } from 'angular2-csv';
import { interval, Subscription } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { ConformationComponent } from '../conformation/conformation.component';
import { RankedChoiceResComponent } from '../ranked-choice-res/ranked-choice-res.component';
addMore(Highcharts)

@Component({
  selector: 'app-ranked-choice-voting-dialog',
  templateUrl: './ranked-choice-voting-dialog.component.html',
  styleUrls: ['./ranked-choice-voting-dialog.component.scss']
})
export class RankedChoiceVotingDialogComponent implements OnInit, OnDestroy {
  @ViewChild(Angular2CsvComponent) csvComponent: Angular2CsvComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['member_name','division','response','parsed_response','replied','id'] ;
  dataSource :any;
  showSpinner = false;
  smsInfoUrl;
  pollResultId;
  pollResult;
  OptionSpecificResult = [];
  poll;
  pollexecute;
  pollOptions = [];
  correctOptiion;
  highcharts1 = Highcharts;
  chartOptions1:any
  hideStopexecutingButton = false;

  private timeValue: Subscription;
  private timeValue1: Subscription;
  showProgressBar = false;
  value = 0;
  valueInstance;
  options;
  data1;
  pollInfo;
  displayedColumns1 = ['Round'];
  displayedColumns2 = ['Round','Pizza','Burger', 'Sushi','Salad', 'Pasta'];
  testPolLResult1=[];
  optionList = [];
  totalvoteCount;
  totalPartcipent;
  notRepliedCount;
  testPolLResult=[['Pizza','Burger', 'Sushi','Salad', 'Pasta'],
  ['Pizza','Burger', 'Sushi','Salad', 'Pasta'],
  ['Pizza','Burger', 'Sushi','Pasta', 'Salad'],
  ['Burger','Sushi', 'Pizza','Salad', 'Pasta'],
  ['Burger','Sushi', 'Pizza','Pasta', 'Salad'],
  ['Sushi','Burger', 'Pizza','Salad', 'Pasta'],
  ['Pizza','Burger', 'Sushi','Pasta', 'Salad'],
  ['Salad','Sushi', 'Pizza','Burger', 'Pasta'],
  ['Salad','Sushi', 'Pizza','Pasta', 'Burger'],
  ['Burger','Sushi', 'Pizza','Pasta', 'Salad'],
  ['Pasta','Sushi', 'Pizza','Salad', 'Burger'],
  ['Burger','Sushi', 'Pizza','Pasta', 'Salad'],
  ['Salad','Pasta', 'Pizza','Burger', 'Sushi'],

  ];

  pollTabledata = [];
  pollResultList = [];
  optionList1 = ['Pizza','Burger', 'Sushi','Salad', 'Pasta'];
  test = {'option 1':3}
  test1 = {'option 1':[1,3,5]}
  eliminatedOption = [];
  totalValue=13;

  constructor(public dialogRef: MatDialogRef<RankedChoiceVotingDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog) {
    // this.showSpinner = true;
    this.pollResultId = data.id;
    this.highcharts1 = Highcharts;
  }

  ngOnInit(): void {
    // debugger;
    this.showSpinner = true;
    this.smsInfoUrl = window.location.origin + '/home/sms-detail/';
    
    this._apiService.pollResultsList(this.pollResultId).subscribe(res => {
      if (res) {
        debugger;
          this.showSpinner = false;
          console.log( res)
          this.pollInfo = res;
          this.OptionSpecificResult = res.results;
          let inst = JSON.parse(JSON.stringify(res.results));
          this.dataSource = new MatTableDataSource<pollResultLists>(inst);
          setTimeout(() => this.dataSource.paginator = this.paginator);
          setTimeout(() => this.dataSource.sort = this.sort);
          this.poll = res.poll;
          this.pollexecute = res.poll_execute;
          this.pollOptions = res.poll_options;
          this.correctOptiion = res.poll_options.filter(ele => ele.id == res.poll.correct_option)[0];
          this.totalPartcipent = res.results.length;
          console.log(this.correctOptiion);
          if(this.pollOptions){
            for(let i =0; i<this.pollOptions.length; i++){
              // this.displayedColumns1.push(this.pollOptions[i].name);
              this.optionList.push(this.pollOptions[i].name)
            }
          }
          this.optionList = this.optionList.sort(); 
          this.displayedColumns1 = this.displayedColumns1.concat(this.optionList);
          console.log(this.optionList);
    console.log(this.displayedColumns1);
    console.log(this.pollTabledata);
          this.handledata();
          this.progressBarInfo();
          this.getVoteingResult(res.results);
          this.countVote();
      }
    },
    (error)=>{
      this.showSpinner = false;
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
    
    
  }

  getVoteingResult(result){
    let resultList = []
    let notRepliedCount = 0;
    if(result){
      for(let i =0; i<result.length; i++){
        if(result[i].user_ranking){
          resultList.push(result[i].user_ranking);
        }else{
          notRepliedCount = notRepliedCount + 1;
        }
      }
    }

    
    this.testPolLResult1 = resultList;
    this.totalvoteCount = resultList.length;
    console.log('resultList',resultList);
    console.log('notRepliedCount',notRepliedCount);
    this.notRepliedCount = notRepliedCount;
  }

  countVote(){
    debugger;
    let optionToElemenate = '';
    if(this.pollTabledata.length > 0){
      let latestResult = this.pollTabledata[this.pollTabledata.length - 1];
      let optionWon = false;

      let valueList: number[] = Object.values(latestResult);
      let sorted_arr = valueList.slice().sort();
      let duplicateValues = [];
      for (let i = 0; i < sorted_arr.length - 1; i++) {
        if (sorted_arr[i + 1] == sorted_arr[i]) {
          duplicateValues.push(sorted_arr[i]);
        }
      }
      let highestVoteCount = 0;
      // var largest= 0;
      for (let i=0; i<=valueList.length;i++){
        if (valueList[i]>highestVoteCount) {
          highestVoteCount=valueList[i];
        }
      }

      

      
      for (const item in latestResult) {
        console.log(latestResult[item])
        if(latestResult[item] > this.testPolLResult1.length/2){
          optionWon = true;
        }
      }

      if(optionWon){
        return;
      }else if(duplicateValues.includes(highestVoteCount) && this.testPolLResult1.length > 10){
        let optionToElemenateList = Object.keys(latestResult).filter(key => latestResult[key] === highestVoteCount);
        for(let i=0;i<this.testPolLResult1.length; i++){
          if(optionToElemenateList.includes(this.testPolLResult1[i][0])){
            console.log(this.testPolLResult1)
            this.testPolLResult1[i].shift();
          }
        }
        this.addNewRound();
      }else{
        let smallestNum = latestResult[this.optionList[0]];
        var elemenateOpt;
        for(const item in latestResult) {
          if(latestResult[item] < smallestNum) {
            smallestNum = latestResult[item]; 
            elemenateOpt = item;
          }
        }  
        this.eliminatedOption.push(elemenateOpt);
        for(let i=0;i<this.pollResultList[this.pollResultList.length-1][elemenateOpt].length; i++){
          this.testPolLResult1[this.pollResultList[this.pollResultList.length-1][elemenateOpt][i]].shift();
        }
        this.addNewRound();
      }
    }else {
      this.addNewRound();
    }
    
  }

  addNewRound(){
    // debugger;
    let voteResult = {};
    let voteData = {};
    if(this.eliminatedOption.length > 0){
      this.removeEliminatedOptionFromFirstplace();
    }
    for(let i=0; i<this.testPolLResult1.length; i++){
      let opt = this.testPolLResult1[i][0];
      console.log(opt);
      if (opt in voteResult){
        let indexList = []
        indexList = voteData[opt];
        indexList.push(i);
        voteData[opt] = indexList;
        voteResult[opt] = voteResult[opt] +1
      }else{
        voteResult[opt] = 1;
        voteData[opt] = [i];
      }
    }
    
    let viewResult1 = {};
    // if(Object.keys(voteResult).length < this.optionList.length){
      for(let i=0; i<this.optionList.length; i++){
        const instance = this.optionList[i];
        let valInst = voteResult[this.optionList[i]];
        valInst = valInst;
        // viewResult1[instance] = voteResult[this.optionList[i]];
        Object.defineProperty(viewResult1, instance, {value:valInst,enumerable: true, writable: true, configurable: true});
      }
    // }
    console.log(voteResult);
    this.pollTabledata.push(viewResult1);
    this.pollResultList.push(voteData);
    console.log('pollTabledata',this.pollTabledata);
    this.countVote();
  }

  removeEliminatedOptionFromFirstplace(){
    // debu gger;
    let elementRemoved = false;
    for(let i=0; i<this.testPolLResult1.length; i++){
      let opt = this.testPolLResult1[i][0];
      if(this.eliminatedOption.includes(opt)){
        this.testPolLResult1[i].shift();
        elementRemoved = true;
      }
    }
    if(elementRemoved){
      this.removeEliminatedOptionFromFirstplace();
    }
  }

  refreshPollResult(){
    // this.showSpinner = true;
    this._apiService.pollResultsList(this.pollResultId).subscribe(res => {
      if (res) {
          this.showSpinner = false;
          console.log( res)
          this.OptionSpecificResult = res.results;
          this.dataSource = new MatTableDataSource<pollResultLists>(res.results);
          setTimeout(() => this.dataSource.paginator = this.paginator);
          setTimeout(() => this.dataSource.sort = this.sort);
          this.poll = res.poll
          this.pollexecute = res.poll_execute
          this.pollOptions = res.poll_options
          this.handledata();
          let resultInstance = [];
          for(let i=0; i<this.OptionSpecificResult.length; i++){
            if(this.OptionSpecificResult[i].replied == false){
                resultInstance.push(this.OptionSpecificResult[i]);
            }
          }
          if(resultInstance.length == 0 && this.poll.allow_vote_change == false){
            this.cpmpletePollExecutionForspecificexecution();
          }
      }
    },
    (error)=>{
      // this.showSpinner = false;
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }

  openRankedChoiceResultComp(pollresInfo){
    console.log(pollresInfo);
    if(pollresInfo.replied){
      const dialogRef = this.dialog.open(RankedChoiceResComponent, {
        width: '30rem',
        data: {poll:this.pollInfo, pollRes:pollresInfo}
      });
  
      dialogRef.afterClosed().subscribe(result => {
      });
    }else{
      this._snackBar.open('Board member has not voted.', 'OK', { duration: 3000 });
    }
    
    
  }

  progressBarInfo(){
    let today = new Date();
    let date = new Date(this.OptionSpecificResult[0].created_at);
    let timeInMilisec = Math.floor(( today.getTime() - date.getTime() ) );
    let effectiveTime = timeInMilisec - this.poll.expiry_time*1000;
    console.log(effectiveTime)
    let timediff = this.poll.expiry_time*10;
    this.valueInstance = timeInMilisec/timediff;
    this.value = this.valueInstance;
    console.log(this.valueInstance)
    console.log(timeInMilisec);
    if(effectiveTime < 0  && this.pollexecute.completed == false){
      this.showProgressBar = true;
      this.timeValue = interval(timediff).subscribe(x => {
          this.value = this.valueInstance + x ;
          if(this.value<100){
            console.log('inside progressbar controller.')
            console.log(x);
          }else{
            this.showProgressBar = false;
            this.cpmpletePollExecution();
            this.timeValue.unsubscribe();
            this.timeValue1.unsubscribe();
          }
      });
    } else {
      this.cpmpletePollExecutionafterCompletion();
    }

    if(this.pollexecute.completed == false){
      this.timeValue1 = interval(30000).subscribe(x => {
          if(this.valueInstance >99){
            this.timeValue1.unsubscribe();
          }
          this.refreshPollResult();
          console.log(x);
          
      });
    }
  }

  checkForAllReplays(){
    let resultInstance = [];
    for(let i=0; i<this.OptionSpecificResult.length; i++){
      if(this.OptionSpecificResult[i].replied == false){
          resultInstance.push(this.OptionSpecificResult[i]);
      }
    }
    if(resultInstance.length == 0 && this.poll.allow_vote_change == false){
      this.cpmpletePollExecutionForspecificexecution();
    }
  }

  ngOnDestroy(): void {
    if(this.timeValue1){
     this.timeValue1.unsubscribe();
    }
    if(this.timeValue){
     this.timeValue.unsubscribe();
    }
  }

  handledata = () =>{
     let temp = {"No Reply":0,"Invalid Votes":0}
     this.pollOptions.forEach(element =>{
        temp[element.name] = 0
     })
     this.OptionSpecificResult.forEach(element =>{
        if ( element.matched_option>0){
           temp[element.parsed_response] = temp[element.parsed_response] +1
        }
        else if(element.replied && element.matched_option == 0){
           temp["Invalid Votes"] = temp["Invalid Votes"] + 1
        }
        else{
           temp["No Reply"] = temp["No Reply"]+1
        }
     })
     console.log("temp is",Object.keys(temp))
     console.log("temp is",Object.values(temp))
     let instance =[];
     for(var i =0; i <Object.values(temp).length; i++){
        if(this.poll.poll_type == 'quiz' && this.poll.correct_option){
           if(Object.keys(temp)[i] == this.correctOptiion.name){
              let testInstance = { name: Object.keys(temp)[i], data: [Object.values(temp)[i]], color:'green'}
              instance.push(testInstance);
           }else{
              let testInstance = { name: Object.keys(temp)[i], data: [Object.values(temp)[i]]}
              instance.push(testInstance);
           }
        }else{
           let testInstance = { name: Object.keys(temp)[i], data: [Object.values(temp)[i]]}
           instance.push(testInstance);
        }
        
        
     }

     console.log(instance);
     this.chartHandler(instance, Object.values(temp))
  }

  chartHandler = (series,categories)=> {
    let series1 = [{
      name: 'Brands',
      colorByPoint: true,
      data: [{
          name: 'Pizza',
          y: 70
      }, {
          name: 'Burger',
          y: 20
      }, {
          name: 'Fried Chiken',
          y: 10
      }]
  }]
    this.chartOptions1 = {   
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: this.poll.name
      },
      subtitle:{
        text: 'Poll Message: '+this.poll.message
      },
      xAxis:{
        categories: [
            'Votes'
          ]
      },     
      yAxis : {
        min: 0,
        title: {
            text: 'Vote Counts'         
        }      
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions : {
        column: {
            pointPadding: 0.2,
            borderWidth: 0
        }
      },
      // series: series.reverse()
      series: series1
    };
  }


  downloadCSV() {
    if(this.poll.poll_type == 'quiz' && this.poll.correct_option){
      this.options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          headers: ['Member Name','From','To','Replied','Poll Execution Time','Last Replied Time', 'Inbound Sid', 'Outbound Sid', 'Company Id','Error Code','Error','Response','Matched Option','Correct Answer'],
          showTitle: true,
          title: this.poll.name,
          useBom: false,
          removeNewLines: true,
          keys: ['member_name','from','to','replied','created_at','updated_at', 'inbound_sid', 'outbound_sid', 'company_id','error_code','error','response','parsed_response','CorrectAnswer' ]
        };
      let optionSpecificResultForDownload = [];
      let instance = {};
      for(let i=0; i<this.OptionSpecificResult.length; i++){
          instance = this.OptionSpecificResult[i];
          if(this.OptionSpecificResult[i].matched_option == this.poll.correct_option){
            instance['CorrectAnswer'] = true;
          }else {
            instance['CorrectAnswer'] = false;
          }
          if(!this.OptionSpecificResult[i].parsed_response){
            instance['parsed_response'] = 'No Reply'
          }
          console.log(instance);
          optionSpecificResultForDownload.push(instance);
      }
      this.data1 = optionSpecificResultForDownload;
      setTimeout(() => { this.csvComponent.onDownload(); }, 0);
    }else if(this.poll.poll_type == 'ranked-choice') {
      this.options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          headers: ['Member Name','From','To','Replied','Division','Voting Preference','Poll Execution Time','Last Replied Time', 'Inbound Sid', 'Outbound Sid', 'Company Id','Error Code','Error','Response','Matched Option'],
          showTitle: true,
          title: this.poll.name,
          useBom: false,
          removeNewLines: true,
          keys: ['member_name','from','to','replied','division','user_ranking', 'created_at','updated_at', 'inbound_sid', 'outbound_sid', 'company_id','error_code','error','response','parsed_response' ]
      };
      let optionSpecificResultForDownload = [];
      let instance = {};
      for(let i=0; i<this.OptionSpecificResult.length; i++){
          instance = this.OptionSpecificResult[i];
          if(!this.OptionSpecificResult[i].parsed_response){
            instance['parsed_response'] = 'No Reply'
          }
          instance['user_ranking'] = JSON.stringify(this.OptionSpecificResult[i].user_ranking);
          console.log(instance);
          optionSpecificResultForDownload.push(instance);
      }
      this.data1 = optionSpecificResultForDownload;
      setTimeout(() => { this.csvComponent.onDownload(); }, 0);
    }else {
      this.options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          headers: ['Member Name','From','To','Replied','Division','Poll Execution Time','Last Replied Time', 'Inbound Sid', 'Outbound Sid', 'Company Id','Error Code','Error','Response','Matched Option'],
          showTitle: true,
          title: this.poll.name,
          useBom: false,
          removeNewLines: true,
          keys: ['member_name','from','to','replied','division', 'created_at','updated_at', 'inbound_sid', 'outbound_sid', 'company_id','error_code','error','response','parsed_response' ]
      };
      let optionSpecificResultForDownload = [];
      let instance = {};
      for(let i=0; i<this.OptionSpecificResult.length; i++){
          instance = this.OptionSpecificResult[i];
          if(!this.OptionSpecificResult[i].parsed_response){
            instance['parsed_response'] = 'No Reply'
          }
          console.log(instance);
          optionSpecificResultForDownload.push(instance);
      }
      this.data1 = optionSpecificResultForDownload;
      setTimeout(() => { this.csvComponent.onDownload(); }, 0);
    }
    
    // new Angular2Csv(data, this.formula, options);
  }

  close(){
    this.dialogRef.close();
  }

  cpmpletePollExecutionForspecificexecution(){
    this.cpmpletePollExecution();
    this.showProgressBar = false;
    this.hideStopexecutingButton = true;
  }

  cpmpletePollExecution(){
    this._apiService.cpmpletePollExecution(this.pollexecute.id).subscribe(res => {
      if (res) {
          console.log( res)
          this.dialogRef.close();
      }
    },
    (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }

  cpmpletePollExecutionafterCompletion(){
    this._apiService.cpmpletePollExecution(this.pollexecute.id).subscribe(res => {
      if (res) {
        console.log( res)
      }
  },
  (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
  });
  }

  startVoteingForLivePoll(){
    this._apiService.startLivePollVoteing(this.pollexecute.id).subscribe(res => {
      if (res) {
          console.log( res)
          this.refreshPollResult();
      }
    },
    (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }

  sendReminder(){
    this._apiService.sendReminder(this.pollexecute.id).subscribe(res => {
      if (res) {
          this._snackBar.open(res, 'OK', { duration: 3000 });
          console.log( res)
      }
    },
    (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
    });
  }


}

export interface pollResultLists {
  company_id: number;
  created_at: string;
  error: string;
  error_code: number;
  from: string;
  id: number;
  inbound_sid: string;
  matched_option: number;
  member_id: number;
  member_name: string;
  outbound_sid: string;
  parsed_response: string;
  poll_execute_id: number;
  poll_id: number;
  replied: boolean;
  response: string;
  status: string;
  to: string;
  updated_at: string;
  division:string;
  user_ranking:[];
};

